import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const REVIEW_PAGE_TITLE_ACTION_REQUEST = 'REVIEW_PAGE_TITLE_ACTION_REQUEST';
export const REVIEW_PAGE_TITLE_ACTION_SUCCESS = 'REVIEW_PAGE_TITLE_ACTION_SUCCESS';
export const REVIEW_PAGE_TITLE_ACTION_ERROR = 'REVIEW_PAGE_TITLE_ACTION_ERROR';

export function reviewPageTitleActionRequest() {
	return { type: REVIEW_PAGE_TITLE_ACTION_REQUEST };
}
export function reviewPageTitleActionSuccess(data) {
	return { type: REVIEW_PAGE_TITLE_ACTION_SUCCESS, data };
}
export function reviewPageTitleActionError(error) {
	return { type: REVIEW_PAGE_TITLE_ACTION_ERROR, error };
}

export function fetchProductReviewTitle(rating, reviewText) {
	return dispatch => {
		dispatch(reviewPageTitleActionRequest());
		return ApiCaller.put(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/reviews/product/title'
			}),
			{
				rating: rating,
				reviewText: reviewText
			}
		).then(
			json => dispatch(reviewPageTitleActionSuccess(json['RESPONSE'])),
			err => {
				return Promise.reject(dispatch(reviewPageTitleActionError(err)));
			}
		);
	};
}
